import request from "@/utils/request";
const config = require("@/../config/config.json");
const endpointBasePrefix = "preferences";

export async function svc_getGlobalBrandSelected() {
	return request(`${config.apiUrl}${endpointBasePrefix}/currentBrand`, {
		method: "GET",
	});
}

export async function svc_saveGlobalBrandSelected(params) {
	return request(`${config.apiUrl}${endpointBasePrefix}/currentBrand/save`, {
		method: "PUT",
		data: params,
	});
}

export async function svc_getMemo2(params) {
	return request(`${config.apiUrl}${endpointBasePrefix}/memo2`, {
		method: "GET",
	});
}

export async function svc_saveMemo2(params) {
	return request(`${config.apiUrl}${endpointBasePrefix}/memo2`, {
		method: "POST",
		data: params,
	});
}

export async function svc_getAllBrands(params) {
	return request(`${config.apiUrl}${endpointBasePrefix}/all-brands`, {
		method: "GET",
	});
}
